<template>
    <div>
        <div v-if="!data || !data.length" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div class="table">
			<table>
				<thead>
					<tr>
						<td v-for="(date, index) in dates"
							:key="index">
                            {{ date }}
						</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(answerRow, rowIndex) in answers"
						:key="rowIndex">
						<td v-for="(answer, index) in answerRow"
							:key="index"
							:class="[index ===0 ? 'first' : '', typeof(answer) != 'string' && answer ? 'success' : '']">
                            <span v-if="typeof(answer) === 'string'">{{ answer }}</span>
							<i v-else-if="answer" class="el-icon-success"></i>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>

export default {   
    name: 'binary-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		data: {
			type: Array,
		}
    },
    
    methods: {
        isNonBlankAnswer(answer) {
			return answer.trim().length > 0
		},
    },
    computed: {
        dates() {
			let dates = this.data.map(obj => obj.date)
			dates.unshift(this.question.title)
			return dates
        },
        answers() {
			let options = this.question.options.map(option => option.value)
			
			// add "other" option if any
			this.data.forEach(obj => {
				obj.value.forEach(val => {
					if (!options.includes(val))
						options.push(val)
				})
			})


            let answers = []
            options.forEach((option, index) => {
				let answerRow = [option]
				// finds the value of the dates using data obj
				this.data.forEach(obj => {
					answerRow.push(obj.value.includes(option))
				})
                answers.push(answerRow)
            })
            return answers
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
